import React from 'react'

interface Props {
  type?: string
}

/**
 * Displays version type as a styled badge (free, trial, paid, demo)
 */
export const VersionTypeBadge = React.memo((props: Props) => {
  const { type } = props
  if (!type) return null

  const colorClass = ''
  // const colorClass = getVersionTypeBadgeColor(type) || "bg-gray-100 text-gray-800";

  return (
    <span className={`inline-block px-1 py-0 text-xs font-medium rounded-full ${colorClass}`}>
      {type.charAt(0).toUpperCase() + type.slice(1)}
    </span>
  )
})

VersionTypeBadge.displayName = 'VersionTypeBadge'
